import ProfileMetadata from './ProfileMetadata.component';

export default ProfileMetadata;
